import styled, { css } from 'styled-components';

import {
  type Topic,
  TopicCardMode,
  TopicCardSize,
} from '@/helpers/gameCategories';

import { device } from '@/styles/helpers';

export const ScTopicsSelect = styled.div`
  position: relative;
  width: 100%;

  .close {
    position: absolute;
    right: 4px;
    top: 0;
    background-color: #000;
    filter: invert(1);
    border-radius: 50%;
    z-index: 12;
  }
`;

type ScTopicCardProps = Pick<Topic, 'cardMode' | 'cardSize' | 'isModal'>;

export const ScTopicCard = styled.div<ScTopicCardProps>`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  border-radius: 12px;
  height: 96px;
  cursor: pointer;
  overflow: hidden;

  & > .text {
    width: 100%;
    padding: 16px 0 16px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h2 {
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.01em;
      text-transform: uppercase;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-bottom: 0;
    }

    & h2.topic-card__title {
      @media (${device.mobileS}) {
        white-space: normal;
      }
    }

    & > a {
      margin-top: auto;

      button {
        max-width: max-content;
      }
    }
  }

  .content {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 8px;

    .topic-img {
      height: 100%;
      object-fit: contain;
      object-position: bottom;
      transition: transform 0.3s ease-in-out;
    }

    .arrow {
      flex-shrink: 0;
      width: 16px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 12px;

      & > i {
        color: ${({ theme }) => theme.color2};
        transition: transform 0.2s ease-in-out;
        transform: translateX(0) scale(1);
      }
    }
  }

  ${({ cardMode, theme }) =>
    cardMode === TopicCardMode.LIGHT
      ? css`
          background-color: ${theme.gray1Color};
          position: relative;

          h2 {
            color: ${({ theme }) => theme.blackColor};
          }

          @media (${device.mobileS}) {
            background-color: transparent;
            border: 1px solid rgba(255, 255, 255, 0.2);

            .content {
              .topic-img {
                height: calc(100% - 2px);
              }
            }
          }
        `
      : css`
          background-color: ${({ theme }) => theme.grayLightColor};
          h2 {
            color: ${({ theme }) => theme.whiteColor};
          }
        `}

  ${({ cardSize }) =>
    cardSize === TopicCardSize.LG &&
    css`
      grid-template-columns: 1fr 0.88fr;
      height: 176px;
      cursor: default;

      & > .text {
        padding: 24px;
        padding-right: 0;
      }

      .content {
        .topic-img {
          width: 100%;
          height: 176px;
        }
      }
    `}

  @media (hover: hover) {
    &:hover {
      & > .content {
        .topic-img {
          transform: scale(1.1);
        }
      }

      .arrow i {
        transform: translateY(-2px) scale(1.05);

        color: ${({ theme }) => theme.blackColor};
      }
    }
  }
`;
